import { render, staticRenderFns } from "./GiftCertificate.vue?vue&type=template&id=71e81fb0"
import script from "./GiftCertificate.vue?vue&type=script&lang=ts"
export * from "./GiftCertificate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports